<template>
    <div id="page-wifi-list">
        <div class="vx-card p-6">
            <div class="mt-4">
                <vs-tabs v-model="activeTab" alignment="left">
                    <vs-tab label="Chính sách" icon-pack="feather" icon="icon-book">
                        <div class="vx-row mt-4">
                            <div class="vx-col w-full">
                                <div class="flex flex-wrap items-center justify-end">
                                    <vs-button class="ml-4" color="primary" icon="icon-plus" icon-pack="feather"
                                               @click="createPolicy" v-if="isPermissionAdd">{{ $t('policy.create') }}
                                    </vs-button>
                                </div>
                            </div>
                        </div>
                        <div class="vx-col w-full">
                            <div class="vx-row">
                                <div class="vx-col w-full lg:w-1/4 mb-base flex-container" :key="index"
                                     v-for="(policy, index) in policyData">
                                    <vx-card>
                                        <div class="vx-row">
                                            <div class="vx-col w-full sm:w-4/5 md:w-4/5 lg:w-4/5 mb-5 text-primary"
                                                 style="flex-grow: 18; font-size: 19px; font-weight: bold;">
                                                {{ policy.name }}
                                            </div>
                                            <div class="vx-col w-full sm:w-1/5 md:w-1/5 lg:w-1/5"
                                                 style="direction: rtl; padding-right: 0px;">
                                                <vs-dropdown class="cursor-pointer" vs-custom-content vs-trigger-click
                                                             style="flex-grow: 1">
                                                    <feather-icon icon="MoreHorizontalIcon" svgClasses="w-6.5 h-6"
                                                                  class="align-feather"
                                                                  style="color:#9faab6"></feather-icon>
                                                    <vs-dropdown-menu>
                                                        <vs-dropdown-item v-for="(card, indexCard) in optionalCards"
                                                                          :key="indexCard">
                                                            <div style="min-width: 130pt"
                                                                 class="w-full border-bottom  py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
                                                                 @click="editPolicy(card, policy)">
                                                                <span class="font-action">{{
                                                                        card.label
                                                                    }}</span>
                                                            </div>
                                                        </vs-dropdown-item>
                                                    </vs-dropdown-menu>
                                                </vs-dropdown>
                                            </div>
                                        </div>
                                        <div class="vx-row">
                                            <div class="vx-col w-full mb-5">
                                                <p class="text-grey color" style="display: inline-block">
                                                    {{ $t('policy.code') }} : {{ policy.code }} ● </p>
                                                <p class="text-red color ml-1 text-primary"
                                                   style="display: inline-block; font-weight: bold;">
                                                    {{ $t('policy.availability') }}
                                                </p>
                                            </div>
                                        </div>
                                        <div class="vx-row mb-2">
                                            <div class="vx-col w-full">
                                                <div style="display: flex">
                                                    <feather-icon class="" icon="AlignRightIcon"
                                                                  svgClasses="w-4 h-4 mr-2"/>
                                                    <p class="text-darkgreen color text-primary"
                                                       style="display: inline-block; font-weight: bold">
                                                        {{ $t('policy.content') }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="vx-col" style="margin-left: 22px;">
                                                <span v-html="policy.description"></span>
                                            </div>
                                        </div>
                                        <div class="vx-row">
                                            <div class="vx-col w-full mt-5">
                                                <div style="display: flex">
                                                    <feather-icon class="" icon="FolderIcon"
                                                                  svgClasses="w-4 h-4 mr-2"/>
                                                    <p class="text-darkgreen color text-primary"
                                                       style="display: inline-block; font-weight: bold;">
                                                        {{ $t('policy.leaveType') }}
                                                    </p>
                                                </div>
                                            </div>
                                            <div class="vx-col" style="margin-left: 22px;">
                                                <p style="display: inline-block" class="font-bold">
                                                    {{ policy.type == 0 ? 'Cố định' : 'Thay đổi theo tháng' }}
                                                </p>
                                            </div>
                                        </div>
                                    </vx-card>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab :label="$t('policy.participants')" icon-pack="feather" icon="icon-users" v-if="isPermissionViewOnLeve">
                        <on-leave></on-leave>
                    </vs-tab>
                </vs-tabs>
            </div>
        </div>
        <vs-popup :title="$t('policy.editPolicy')" :active.sync="updatePolicy" class="vs-popup">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <label class="vs-input--label">{{ $t('policy.policyName') }}</label>
                    <span class="text-danger">*</span>
                    <vs-input class="w-full" v-model="policyEdit.name" v-validate="'required'" name="policyName">
                    </vs-input>
                    <span class="text-danger text-sm">{{ errors.first('policyName') }}</span>
                </div>
            </div>
            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <label class="vs-input--label">{{ $t('policy.code') }}</label>
                    <span class="text-danger">*</span>
                    <vs-input class="w-full" v-model="policyEdit.code" v-validate="'required'" name="policyCode">
                    </vs-input>
                    <span class="text-danger text-sm">{{ errors.first('policyCode') }}</span>
                </div>
                <div class="vx-col w-full mt-4">
                    <label class="vs-input--label">{{ $t('policy.type') }}</label>
                    <span class="text-danger">*</span>
                    <v-select v-model="policyTypeModel" :options="policyTypeOptions" :clearable="false"
                              v-validate="'required'" name="policyType"></v-select>
                    <span class="text-danger text-sm">{{ errors.first('policyType') }}</span>
                </div>
            </div>
            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <label class="vs-input--label">{{ $t('policy.annualLeave') }}</label>
                    <span class="text-danger">*</span>
                    <vs-input class="w-full" v-model="policyEdit.annualLeave" v-validate="'required|decimal:1'"
                              type="number" step="0.5" min="0" name="annualLeave"></vs-input>
                    <span class="text-danger text-sm">{{ errors.first('annualLeave') }}</span>
                </div>
            </div>
            <div class="vx-row">
                <div class="vx-col w-full mt-5 mb-4 quill-editor">
                    <label class="vs-input--label">{{ $t(policy.policyContent) }}</label>
                    <span class="text-danger">*</span>
                    <quill-editor class="input-description" v-model="policyEdit.description" v-validate="'required'"
                                  name="policyContent"></quill-editor>
                    <span class="text-danger text-sm">{{ errors.first('policyContent') }}</span>
                </div>
            </div>
            <div class="vx-row mt-4">
                <div class="vx-col w-full md:w-1/2">
                    <vs-button color="primary" type="border" class="w-full" @click="saveChangePolicy"
                               :disabled="!validateForm" v-if="isPermissionUpdate">{{ $t('policy.save') }}
                    </vs-button>
                </div>
                <div class="vx-col w-full md:w-1/2">
                    <vs-button color="primary" type="border" class="w-full" @click="closePopup">{{
                            $t('policy.cancel')
                        }}
                    </vs-button>
                </div>
            </div>
        </vs-popup>
        <vs-popup title="Chính sách thâm niên" :active.sync="updatePolicySeniority">
            <div class="vx-row">
                <div class="vx-col w-full">
                    <label class="vs-input--label">{{ $t('policy.policyName') }}</label>
                    <span class="text-danger">*</span>
                    <vs-input class="w-full" v-model="policyEdit.name" v-validate="'required'" name="policyName">
                    </vs-input>
                    <span class="text-danger text-sm">{{ errors.first('policyName') }}</span>
                </div>
            </div>
            <div class="vx-row mt-4">
                <div class="vx-col md:w-5/12 w-full">
                    <div>
                        <p class="text-darkgreen color text-primary" style="display: inline-block">
                            {{ $t('policy.numberOfMonthWorked') }}
                        </p>
                    </div>
                </div>
                <div class="vx-col md:w-5/12 w-full">
                    <div>
                        <p class="text-darkgreen color text-primary" style="display: inline-block">
                            {{ $t('policy.extraDayOff') }}
                        </p>
                    </div>
                </div>
            </div>
            <div :key="index" v-for="(item, index) in seniorityLeaves" class="vx-row mt-1 mb-4">
                <div class="vx-col w-full md:w-5/12">
                    <vs-input class="w-full" v-model="item.monthService" v-validate="'required|numeric'"
                              :name="'Vị trí Số tháng đã làm việc số ' + (index + 1)"></vs-input>
                    <span class="text-danger text-sm">{{
                            errors.first('Vị trí Số tháng đã làm việc số ' + (index + 1))
                        }}</span>
                </div>
                <div class="vx-col w-ful md:w-5/12">
                    <vs-input class="w-full" v-model="item.dayGranted" v-validate="'required|numeric'"
                              :name="'Vị trí Số ngày nghỉ thưởng thêm số ' + (index + 1)"></vs-input>
                    <span class="text-danger text-sm">{{
                            errors.first('Vị trí Số ngày nghỉ thưởng thêm số ' + (index +
                                1))
                        }}</span>
                </div>
                <div class="vx-col">
                    <vx-tooltip color="primary" :text="$t('policy.delete')">
                        <vs-button color="primary" type="border" icon-pack="feather" icon="icon-trash-2"
                                   @click="removeSeniority(index)"></vs-button>
                    </vx-tooltip>
                </div>
            </div>
            <div class="vx-row mt-4">
                <div class="vx-col w-full">
                    <vx-tooltip color="primary" :text="$t('policy.create')">
                        <vs-button color="primary" type="border" icon-pack="feather" icon="icon-plus"
                                   @click="addMultiOption(indexSeniority)">
                        </vs-button>
                    </vx-tooltip>
                </div>
            </div>
            <div class="vx-row mt-4">
                <div class="vx-col w-full md:w-6/12">
                    <vs-button color="primary" class="w-full" @click="saveChangePolicy"
                               :disabled="!validateForm">{{ $t('policy.save') }}
                    </vs-button>
                </div>
                <div class="vx-col w-full md:w-6/12">
                    <vs-button color="danger" type="border" class="w-full" @click="closePopup">{{
                            $t('policy.cancel')
                        }}
                    </vs-button>
                </div>
            </div>
        </vs-popup>
    </div>
</template>

<script>

import vSelect from 'vue-select'
import 'quill/dist/quill.snow.css';
import {quillEditor} from 'vue-quill-editor'
import OnLeave from '../leave/OnLeave.vue';
import {isAPI, isRouter} from '../../../../store/permission';
import {constAPI, constRouter} from '../../../../store/constant';

export default {
    components: {
        vSelect,
        quillEditor,
        OnLeave
    },
    data() {
        return {
            userInfo: {},
            policy: {},
            policyEdit: {},
            activeTab: 0,
            searchQuery: null,
            policyData: [],

            optionalCards: [
                {label: 'Chỉnh sửa chính sách', value: 0},
                {label: 'Nghỉ phép thưởng theo thâm niên', value: 1},
                {label: 'Xóa', value: 2},
            ],
            selected: [],
            listUsers: [],
            listBranchs: [],
            branchName: null,
            selectedOrganizationBrachId: null,

            valueSelectedStatus: null,
            updatePolicy: false,
            updatePolicySeniority: false,
            policyTypeOptions: [
                {label: 'Cố định', value: 0},
                {label: 'Thay đổi theo tháng', value: 1},
            ],
            indexSeniority: 0,
            seniorityLeaves: [],
            policyId: null,

        }
    },
    async created() {
        if (!this.isPermissionDelete) {
            this.optionalCards = this.optionalCards.filter(el => el.value !== 2)
        }
        let checkTabs = this.$route.query.activeTabs;
        if (checkTabs) {
            this.activeTab = 1
        } else {
            this.activeTab = 0
        }
        this.initScreen();

        await this.getAllListBranch();
        let userInfo = JSON.parse(localStorage.getItem('userInfo'));

        let branchList = this.listBranchs;
        if (userInfo.userRole != 'organization') {
            let branch = branchList.find(el => el.value == userInfo.organizationBranchId);
            this.branchName = branch.label;
            this.levelBranch = branch.patch ? branch.patch.split('/').length : null;
            this.selectedOrganizationBrachId = userInfo.organizationBranchId;
        } else {
            this.branchName = userInfo.username.toUpperCase();
            this.levelBranch = 0;
            this.listBranchs.unshift({label: userInfo.username.toUpperCase(), value: null})
        }
        this.userInfo = userInfo;
    },
    watch: {
        statusEmployee() {
            this.getEmployee();
        },

        '$store.state.isUpdatePolicy'(val) {
            if (val) {
                this.initScreen();
                this.$store.commit('UPDATE_POLICY', false);
            }
        }


    },
    computed: {

        validateForm() {
            return !this.errors.any()
        },

        policyTypeModel: {
            get() {
                let x = this.policyTypeOptions.find(item => item.value == this.policyEdit.type);
                if (!x) {
                    return
                }
                return {
                    label: x.label,
                    value: x.value
                }
            },
            set(obj) {
                this.policyEdit.type = obj.value;
            }
        }

    },
    methods: {
        isPermissionAdd() {
            return isRouter(this, constRouter.policy_add)
        },
        isPermissionUpdate() {
            return isAPI(this, constAPI.policy_update)
        },
        isPermissionDelete() {
            return isAPI(this, constAPI.policy_delete)
        },
        isPermissionViewOnLeve() {
            return isAPI(this, constAPI.policy_all)
        },

        createOnLeave() {
            this.$router.push('user/manage-onleave');
        },

        editPolicy(card, policy) {
            switch (card.value) {
                case 0:
                    this.updatePolicy = true;
                    this.findById(policy.id);
                    this.$validator.reset();
                    break;
                case 1:
                    this.updatePolicySeniority = true;
                    this.findById(policy.id);
                    this.$validator.reset();
                    break;
                case 2:
                    this.confirmDeletePolicy(policy.id);
                    break;
            }
        },

        initScreen() {
            this.getData();

        },
        updateSearchQuery() {
        },

        createPolicy() {
            this.$router.push('/user/manage-policy-info');
        },
        filterDataByOrganizationBranchId: function (item) {
            this.branchName = null;
            this.selectedOrganizationBrachId = item.value;
            this.branchName = item.label;
        },

        getAllListBranch: function () {
            return new Promise((resolve, reject) => {
                this.$crm.post('/organization-branch/all').then((response) => {
                    this.listBranchs = response.data.map(el => {
                        return {
                            label: el.organizationBranchName,
                            value: el.id,
                            patch: el.patch
                        }
                    });
                    this.$vs.loading.close();
                    resolve();
                }).catch(() => {
                    reject();
                    this.$vs.loading.close();
                });
            })
        },

        getEmployee() {

        },

        getData() {
            this.$vs.loading();
            let policy = {}
            this.$crm.post('policy/find-by-condition', policy).then((response) => {
                this.$vs.loading.close();
                this.policyData = response.data;
            }).catch(() => {
                this.$vs.loading.close();
            });
        },

        findById(id) {
            this.$vs.loading();
            this.$crm.post('/policy/find-by-id/' + id).then((response) => {
                this.$vs.loading.close();
                this.policyEdit = response.data;
                this.seniorityLeaves = response.data.seniorityLeaves;
            }).catch(() => {
                this.$vs.loading.close();
            });
        },

        addMultiOption(index) {
            this.indexSeniority += 1;
            this.seniorityLeaves.splice(index, 0, {});
        },

        async saveChangePolicy(el) {

            el.preventDefault();
            if (!this.validateForm) return;
            const result = await this.$validator.validateAll();
            if (!result) return;

            this.$vs.loading();
            this.policyEdit.seniorityLeaves = this.seniorityLeaves;
            this.$crm.post('/policy/update', this.policyEdit).then((response) => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Cập nhật chính sách thành công',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                });
                this.updatePolicy = false;
                this.updatePolicySeniority = false;
                this.getData();
            }).catch(() => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: 'Cập nhật chính sách thất bại',
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle'
                });
            });
        },

        closePopup() {
            this.updatePolicy = false;
            this.updatePolicySeniority = false;
        },

        confirmDeletePolicy(id) {
            this.policyId = id;
            this.$vs.dialog({
                type: 'confirm',
                color: 'danger',
                title: `Xác nhận xoá`,
                text: `Bạn có chắc là muốn xoá chính sách này không ?`,
                accept: this.deletePolicy,
                acceptText: "Xoá",
                cancelText: "Huỷ"

            });
        },

        deletePolicy() {
            this.$vs.loading();
            this.$crm.post('/policy/delete/' + this.policyId).then(() => {
                this.$vs.loading.close()
                this.$store.commit('UPDATE_POLICY', true);
                // if () {}
                this.$vs.notify({
                    text: 'Xóa chính sách thành công',
                    color: 'success',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
                this.getData();
            }).catch((err) => {
                this.$vs.loading.close();
                this.$vs.notify({
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    color: 'danger',
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                });
            });
        },

        removeSeniority(index) {
            this.seniorityLeaves.splice(index, 1);
        }
    }
}
</script>

<style scoped>
#btn-popup {
    float: right;
}

.btn-popup1 {
    float: right !important;
}

.icon-type {
    width: 16px;
    height: 16px;
}

.card-img-top {
    height: 189px;
}

.feather-bell {
    color: #2c2c2c !important;
}

.button-popup {
    color: #2c2c2c !important;
    background: white !important;
}

.text-block {
    left: 30px;
    direction: rtl;
    position: absolute;
    top: 1px;
    color: white;
    background-color: rgba(39, 44, 50, 0.7);


    right: 0;
    border-radius: 0px 5px 0px 0px;
    padding: 6px;
}

.container {
    position: relative;
    font-family: Arial;
}

.btn-drop {
    display: inline-block;

}

.filter-btn {
    display: inline-block;
    text-transform: uppercase;
    font-weight: bold;
    color: black;
}

.flex-container {
    display: flex;
    align-items: stretch;
}

span {
    font-weight: 600;
}

.color-type {
    width: 18px;
    height: 100%;
    margin: auto;
    object-fit: contain;
}

#dropdown-menu {
    width: 250px;
}

vs-popup {
    background-color: white;
}


#page-branch-list {
}

.event-display-date {
    flex-flow: row nowrap;
    font-size: 18px;
    justify-content: center;
}

.filter-tab-content {
    width: auto;
    height: 60vh;
    min-width: 700px;
    padding-top: 1rem
}
</style>
